// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"S2-z","displaySixCardTiles":"T2-z"};